export default __webpack_public_path__ + "static/cellular_tower-7c83230a3fd398d31f65f97a70ab94d4.svg";